module.exports = __webpack_public_path__ + "5.0.2/img/setting_01.a7084f6b.png";